import React, { useContext, useEffect, useState } from "react";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import organisms from "../../../components/organisms";
import service from "../../../api/services";
import {
    Contact_lens,
    Default_Page_Limit,
    Default_Page_Number,
} from "../../../constants/defaultValues";
import { HeaderHeading } from "../../../Context";
import constant from "../../../constants/constant";
import { useSearchParams } from "react-router-dom";
import { getContactLensType, getParams } from "../../../constants/utils";
import { DropDownType, FilterDataProps, ModifiedDataForContactLensProps } from "./PendingProduct/interface";
import { useToasts } from "react-toast-notifications";

const { ApproveProduct } = organisms;

const Index = () => {
    const { addToast } = useToasts()
    const [searchParams] = useSearchParams();
    const [typeValue, setTypeValue] = useState<any>(getParams("product-type"));
    const [productData, setProductData] = useState<any>({});
    const [currentPage, setCurrentPage] = useState(Default_Page_Number);
    const [productDetail, setProductDetail] = useState({});
    const [limitPerPage, setLimitPerPage] = useState(Default_Page_Limit);
    const [search, setSearch] = useState("");
    const { setHeader }: any = useContext(HeaderHeading);
    const [isContactLensProduct, setIsContactLensProduct] = useState<boolean>(
        getContactLensType()
    );
    const [showFilter, setShowFilter] = useState<boolean>(false);
    const [brandList, setBrandList] = useState<DropDownType[]>([]);
    const [productTypeList, setProductTypeList] = useState<DropDownType[]>([]);
    const [filterData, setFilterData] = useState<FilterDataProps>({
        product_type_id: null,
        brand_id: null,
        modal_number: "",
    });
    const [productId,setProductId]=useState<string>('')

    const getDropdown = (response: []) => {
        let dropdown: any = []
        response && response.map((value: any) => {
            dropdown.push({
                "value": value.id || value.product_type.id,
                "label": value.name || value.brand_name || value.color_name || value.product_type.name,
                "code": value?.brand_code || value?.product_type_initials || value?.product_type?.product_type_initials
            }
            )
        })
        return dropdown
    }

    const getAllDetail = async () => {
        const brands = filterData?.brand_id?.map((item: any) => item?.value)
        const product_types = filterData?.product_type_id?.map((item: any) => item?.value)
        let NewBrands = JSON.stringify(brands)
        let NewProductTypes = JSON.stringify(product_types)

        try {
            let response = await service.product.view({
                page: currentPage,
                search: search,
                limit: limitPerPage,
                status: constant.VERIFICATION_STATUS.VERIFIED,
                brand_category: typeValue,
                is_contact_lens: isContactLensProduct,
                brands: NewBrands,
                product_types: NewProductTypes,
                modal_number: filterData?.modal_number,
            });
            if (response.status === 200) {
                setProductData(response.data);
                localStorage.removeItem("isContactLensProduct");
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getDetailById = async (id: string) => {
        try {
            let response = await service.product.getDetailById(id);
            if (response.status === 200) setProductDetail(response.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    // handle change of filter
    const handleChange = (name: string, value: string | DropDownType) => {
        setFilterData((prevState: FilterDataProps) => ({
            ...prevState,
            [name]: value,
        }));
    };
    // end

    // get the data for filter
    const modifiedDataForContactLens = ({
        data,
        filterCondition,
    }: ModifiedDataForContactLensProps) => {
        return data?.filter(filterCondition) || [];
    };

    const getProductData = async () => {
        try {
            let brandResponse = await service.product.getFilterBrand({
                brand_category: typeValue,
            });
            let productTypeResponse =
                await service.inventory.commonProductTypeListingService({ search: "" });
            setBrandList(getDropdown(brandResponse?.data?.data));
            let modifiedData: any = modifiedDataForContactLens({
                data: productTypeResponse.data.data,
                filterCondition: (item: any) =>
                    item?.name?.toLowerCase() !== Contact_lens,
            });
            if (productTypeResponse.status === 200) {
                setProductTypeList(getDropdown(modifiedData));
            }
        } catch (error) {
            console.error(error);
        }
    };

    // handle the contact lens switch to normal product and vice versa
    const handleChangeContactLens=(value:boolean)=>{
        setIsContactLensProduct(value);
        setFilterData({
            product_type_id: null,
            brand_id: null,
            modal_number: "",
        })
    }
    // end

    //handle the product offline and online
    const handleEcommerceStatus = async () => {
        try {
            const response = await service.product.updateEcommerceStatus(productId)
            if (response.status === 200) {
                getAllDetail()
                setProductId('')
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            console.error(error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }
    //end

    useEffect(() => {
        setTypeValue(getParams("product-type"));
        setProductDetail({});
        setCurrentPage(Default_Page_Number);
        setLimitPerPage(Default_Page_Limit);
        setSearch("");
        getProductData()
        setHeader("Product - Approved");
    }, [searchParams]);

    useEffect(() => {
        getAllDetail();
    }, [currentPage, typeValue, limitPerPage, search, isContactLensProduct,filterData]);


    return (
        <Wrapper>
            <ApproveProduct
                productResponse={productData}
                productDetail={productDetail && productDetail}
                updateVerificationStatus={(id: string, status: number) => { }}
                getDetailById={(id: string) => {
                    getDetailById(id);
                }}
                setLimitPerPage={setLimitPerPage}
                setCurrentPage={setCurrentPage}
                setSearch={setSearch}
                currentPage={currentPage}
                limit={limitPerPage}
                isRecognize={typeValue == constant.BRAND_CATEGORY[0].value}
                setIsContactLensProduct={(value:boolean)=>handleChangeContactLens(value)}
                isContactLensProduct={isContactLensProduct}
                setShowFilter={(value: boolean) => setShowFilter(value)}
                showFilter={showFilter}
                brandList={brandList}
                productTypeList={productTypeList}
                handleChange={handleChange}
                filterData={filterData}
                setProductID={setProductId}
                handleEcommerceStatus={handleEcommerceStatus}
            />
        </Wrapper>
    );
};
export default Index;
